import PropTypes from 'prop-types';
import { useNavigate } from "react-router";
// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import LogoutIcon from '@mui/icons-material/Logout'; // Replaces LogoutOutlined
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'; // Replaces UserOutlined
import LockOutlineIcon from '@mui/icons-material/LockOutline'; // Replaces LockOutlined
import CloseIcon from '@mui/icons-material/Close'; // Replaces { CloseOutlined }

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton } from '@mui/material';
import { useState } from 'react';
import Loader from '../../../../../components/buttonLoader/Loader';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ handleLogout, handleToggle }) {

  const [logoutOpen, setLogoutOpen] = useState(false);
  const [logoutLoader, setLogoutLoader] = useState(false);

  const navigate = useNavigate();
  const goToProfile = () => {
    navigate("/profile");
    if (handleToggle) handleToggle();
  };
  const handleLogoutDialogClose = async () => {
    setLogoutLoader(true);
    await handleLogout();
    setLogoutLoader(false);
    setLogoutOpenFunc(false)
  };
  const setLogoutOpenFunc = (val) => {
    setLogoutOpen(val)
    if (!val) {
      if (handleToggle) handleToggle();
    }
  };
  return (
    <>
      <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
        <ListItemButton onClick={goToProfile}>
          <ListItemText primary="User Profile" />
          <ListItemIcon>
            <PersonOutlineIcon style={{fontSize: '18px'}} />
          </ListItemIcon>
        </ListItemButton>

        <ListItemButton
          onClick={() => {
            navigate('/change-password');
            if (handleToggle) handleToggle();
          }}
        >

          <ListItemText primary="Change Password" />
          <ListItemIcon>
            <LockOutlineIcon style={{fontSize: '18px'}} />
          </ListItemIcon>
        </ListItemButton>

        <ListItemButton onClick={() => setLogoutOpenFunc(true)}>
          <ListItemText primary="Logout" />
          <ListItemIcon>
            <LogoutIcon style={{fontSize: '18px'}} />
          </ListItemIcon>
        </ListItemButton>
      </List>

      <Dialog open={logoutOpen} onClose={(e) => e.stopPropagation()}
        fullWidth maxWidth="xs">
        <DialogTitle>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>Logout Confirmation</span>
            <IconButton onClick={() => setLogoutOpenFunc(false)} >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <Divider sx={{ border: '0.5px solid #eeebeb' }} />

        <DialogContent sx={{ textAlign: 'center', py: 4 }}>
          <div style={{ fontSize: 14, marginTop: 8 }}>
            Are you sure you want to logout?
          </div>
        </DialogContent>

        <Divider sx={{ border: '0.5px solid #eeebeb' }} />

        <DialogActions sx={{ justifyContent: 'center', py: 2 }}>
          <Button variant="contained" color="error" onClick={handleLogoutDialogClose} disabled={logoutLoader}>{logoutLoader ? <Loader /> : 'Logout'}</Button>
          <Button variant="outlined" color="secondary" onClick={() => setLogoutOpenFunc(false)} disabled={logoutLoader}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

ProfileTab.propTypes = { handleLogout: PropTypes.func, handleToggle: PropTypes.func };
